import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import Home from './redirectionToPlacerep/Home';
import LegalLayout from './redirectionToPlacerep/LegalLayout';
import PrivacyPolicy from './redirectionToPlacerep/PrivacyPolicy';
import TermsAndConditions from './redirectionToPlacerep/TermsAndConditions';
import './redirectionToPlacerep/Home.css';
import './redirectionToPlacerep/Legal.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route element={<LegalLayout />}>
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        </Route>
        {/* Anything else falls back to the splash so old deep-links still land somewhere sensible. */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
